import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const SOCIAL_MEDIA_DISCLOSURE_QUERY_KEY = 'socialMediaDisclosure';

export function useSocialMediaDisclosure({
	impersonationContext,
	templateId,
	enabled = true,
}: {
	impersonationContext?: Api.IImpersonationContext;
	templateId?: string;
	enabled?: boolean;
}) {
	const userSession = useUserSession();

	return useQuery({
		enabled: enabled && !!templateId,
		refetchOnWindowFocus: false,
		staleTime: 30_000,
		queryFn: () =>
			userSession.webServiceHelper.callAsync<string>({
				path: Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'social/resolvedDisclosure',
					queryParams: templateId ? { templateId } : undefined,
				}),
				method: 'GET',
				throwOn404: false,
			}),
		retry: 0,
		queryKey: [
			SOCIAL_MEDIA_DISCLOSURE_QUERY_KEY,
			{ templateId, impersonationContextId: impersonationContext?.account?.id },
		],
	});
}

export function invalidateSocialMediaDisclosureQueries() {
	return reactQueryClient.invalidateQueries({ queryKey: [SOCIAL_MEDIA_DISCLOSURE_QUERY_KEY] });
}
